import { useLocation } from 'react-router-dom';
import { Skeleton } from '@/components/ds/Skeleton';
import { PageHeader } from '@/components/ds/PageHeader';
import { PageBodySkeleton, type PageModel } from './PageSkeletons';

// The loading state for a lazy route (ported from DetectHub's ds-detecthub/,
// cascade plan 2.6; mounted as the routes' Suspense fallback in 5.3). It draws
// a masthead with placeholder title lines, each exactly one line of the text it
// stands in for (.dlp-line), then the body in the shape of the page that is
// loading. DetectHub reads its Next.js nav for the shape; DLP reads the path.

const MODEL_BY_PATH: Record<string, PageModel> = {
    '/dashboard': 'dashboard',
    '/downloads': 'cards',
    '/user-manual': 'cards',
    '/settings': 'cards',
    '/upload-blocking': 'cards',
    '/agent-logs': 'table',
    '/audit': 'table',
    '/blocked-events': 'table',
    '/decisions': 'table',
};

// Detail routes (src/app/routes.tsx): one id segment under a list.
const DETAIL = /^\/(policies|agents|admin\/roles|platform\/tenants)\/[^/]+$/;

function modelFor(pathname: string): PageModel {
    const path = pathname.replace(/\/$/, '');
    if (DETAIL.test(path)) return 'detail';
    return MODEL_BY_PATH[path] ?? 'list';
}

export function RouteLoading() {
    const { pathname } = useLocation();
    return (
        <div className="space-y-6">
            <PageHeader
                title={<span className="dlp-line"><Skeleton className="block" variant="text" width={220} height={22} aria-hidden="true" /></span>}
                description={<span className="dlp-line"><Skeleton className="block" variant="text" width={360} height={12} aria-hidden="true" /></span>}
            />
            <PageBodySkeleton model={modelFor(pathname)} />
        </div>
    );
}
